import { render, staticRenderFns } from "./PackageSummary.vue?vue&type=template&id=65506689&scoped=true&"
import script from "./PackageSummary.vue?vue&type=script&lang=js&"
export * from "./PackageSummary.vue?vue&type=script&lang=js&"
import style0 from "./PackageSummary.vue?vue&type=style&index=0&id=65506689&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65506689",
  null
  
)

export default component.exports